import React from 'react';
import MetricTileToneEnum from '../Enums/MetricTileToneEnum';

// Numbers that sum something up, as a row of tiles: a small capitals label over a big number, and a line under it
// when there is one. tiles are { label, value, note, tone }; tone is a MetricTileToneEnum value, plain by default.
// The tiles share the row and wrap onto the next one when it gets narrow.
export default function MetricTiles({ tiles = [] }) {
  return (
    <div className='metric-tiles'>
      {tiles.map((tile) => {
        const tone = tile.tone ?? MetricTileToneEnum.Plain;
        return (
          <div
            key={tile.label}
            className={tone ? `metric-tile ${tone}` : 'metric-tile'}
          >
            <span className='metric-label'>{tile.label}</span>
            <b className='metric-value'>{tile.value}</b>
            {tile.note && <span className='metric-note'>{tile.note}</span>}
          </div>
        );
      })}
    </div>
  );
}
